<template>
  <div>
    <div class="banner">
      <!-- 1.轮播图 -->
      <el-carousel :interval="5000" arrow="hover">
        <el-carousel-item v-for="i in bannerList" :key="i.id">
          <img class="bannerImg" :src="i.content" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 宣传 -->
    <div class="xuanchuan contentCss">
      <div class="first">
        <div class="left">
          <i class="el-icon-date iconCss"> </i>
        </div>
        <div class="right">
          <span class="top"
            ><CountTo
              :startVal="startVal"
              :endVal="endVal"
              :duration="duration"
            />年</span
          ><br />
          <span class="bottom">成立时间</span>
        </div>
      </div>
      <div class="first">
        <div class="left">
          <i class="el-icon-user iconCss"> </i>
        </div>
        <div class="right">
          <span class="top"
            ><CountTo
              :startVal="startVal1"
              :endVal="endVal1"
              :duration="duration1"
            />+</span
          ><br />
          <span class="bottom">电力市场主体</span>
        </div>
      </div>
      <div class="first">
        <div class="left">
          <i class="el-icon-s-data iconCss"> </i>
        </div>
        <div class="right">
          <span class="top"
            ><CountTo
              :startVal="startVal2"
              :endVal="endVal2"
              :duration="duration2"
            />TB+</span
          ><br />
          <span class="bottom">行业数据</span>
        </div>
      </div>
      <div class="first">
        <div class="left">
          <i class="el-icon-document iconCss"> </i>
        </div>
        <div class="right">
          <span class="top">企业征信</span><br />
          <span class="bottom">央行备案</span>
        </div>
      </div>
    </div>
    <!-- 2.产品介绍，图文混排 -->
    <div class="product contentCss">
      <h3 class="h3Text">核心产品</h3>
      <div class="threeBox">
        <div class="text">
          <div class="titleImg">
            <img
              style="width: 50px"
              src="../../assets/creditCommit.png"
              alt=""
            />
          </div>
          <h4>商务信用评价</h4>
          <p>
            依据全维度商务信用评价指标体系，对涉电力领域市场主体在电力生产服务过程中，遵守法律规范、承担社会责任、履行相关合约的意愿、能力和表现进行综合评分。
          </p>
          <div class="DetailBtn" style="margin-top: 45px">
            <el-button type="primary" size="mini" @click="gotoReport"
              >查看详情</el-button
            >
          </div>
        </div>
        <div class="text">
          <div class="titleImg1">
            <img style="width: 50px" src="../../assets/powerIndex.png" alt="" />
          </div>

          <h4>信电查</h4>
          <p>
            信电查是中电联征信为涉电力领域企业为主的市场主体，提供全方位综合性商业查询平台。从行业监管出发、依托行业的征信资质优势，整合市场化大数据资源并以电力行业专有数据为特色，面向社会推出的商业信息查询及分析服务。
          </p>
          <div class="DetailBtn">
            <el-button type="primary" size="mini" @click="gotoCecIndex"
              >查看详情</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 我们的优势 -->
    <div class="product1 contentCss">
      <h3 class="h3Text">我们的优势</h3>
      <div class="threeBox">
        <div class="text">
          <div class="titleImg1">
            <img style="" src="../../assets/youshi1.png" alt="" />
          </div>
          <h4>数据权威</h4>
          <p>
            数据来源权威，直接对接国家工商总局、质量监督总局、税务总局等政府部门数据，采集信用中国、信用能源、全国行政执法数据信息平台一手数据，汇集中电联、电力集团、地方电力能源企业的行业数据。
          </p>
        </div>
        <div>
          <div class="text2">
            <div class="titleImg1">
              <img style="" src="../../assets/youshi3.png" alt="" />
            </div>
            <h4>方案精准</h4>
            <p style="text-align: center">
              满足数据需求，推动数字化转型。<br />
              建立评估机制，综合评价供应商。<br />
              监控全面数据，提供决策性支撑。<br />
            </p>
          </div>
          <div class="text3">
            <div class="titleImg1">
              <img style="" src="../../assets/youshi5.png" alt="" />
            </div>
            <h4>建模专业</h4>
            <p style="text-align: left">
              依托行业先进的模型生命周期管理理念，建设场景化自动化的模型监控体系，基于数据标准构建模型，助力企业完成数字化转型。
            </p>
          </div>
        </div>
        <div class="text1">
          <div class="titleImg1">
            <img style="" src="../../assets/youshi2.png" alt="" />
          </div>
          <h4>行业标准</h4>
          <p>
            数据全面，电力行业特色明显，制定了统一的数据标准和规范，数据清洗优化，规范管理数据资源。提供多种方式如API接口、离线文件、平台直连等帮助合作伙伴接入数据。
          </p>
        </div>
      </div>
    </div>
    <div class="partner contentCss">
      <h3 class="h3Text">合作伙伴</h3>
      <div class="list">
        <span><img src="../../assets/partner16.png" alt="" /></span>
        <span><img src="../../assets/partner17.png" alt="" /></span>
        <span><img src="../../assets/partner18.png" alt="" /></span>
        <span><img src="../../assets/partner19.png" alt="" /></span>
        <span><img src="../../assets/partner20.png" alt="" /></span>
      </div>
      <div class="list">
        <span><img src="../../assets/partner1.png" alt="" /></span>
        <span><img src="../../assets/partner2.png" alt="" /></span>
        <span><img src="../../assets/partner3.png" alt="" /></span>
        <span><img src="../../assets/partner4.png" alt="" /></span>
        <span><img src="../../assets/partner5.png" alt="" /></span>
      </div>
      <div class="list">
        <span><img src="../../assets/partner6.png" alt="" /></span>
        <span><img src="../../assets/partner7.png" alt="" /></span>
        <span><img src="../../assets/partner8.png" alt="" /></span>
        <span><img src="../../assets/partner9.png" alt="" /></span>
        <span><img src="../../assets/partner10.png" alt="" /></span>
      </div>
      <div class="list">
        <span><img src="../../assets/partner11.png" alt="" /></span>
        <span><img src="../../assets/partner12.png" alt="" /></span>
        <span><img src="../../assets/partner13.png" alt="" /></span>
        <span><img src="../../assets/partner14.png" alt="" /></span>
        <span><img src="../../assets/partner15.png" alt="" /></span>
      </div>
    </div>
    <!-- 飘窗广告 -->
 <!--   <MoveWindow
      title="中电联关于开展第六届（2024 年）“信用电力”知识竞赛活动的通知"
      :div-style="{ background: 'rgb(25 124 167 / 90%)', color: '#fff' }"
    >
      <div class="content" style="font-family: 'Times New Roman', Times, 宋体">
        <p>理事长、各副理事长单位，各会员及有关单位:</p>
        <p style="text-indent: 2em">
          为进一步推进电力行业信用体系建设，持续提升涉电力领域从业人员诚信意识和信用管理水平，全面塑造和推广“信用电力”品牌,中国电力企业联合会(简称“中电联”)决定开展第六届(
          2024年)“信用电力”知识竞赛活动(简称“信用知识竞赛”)。具体通知见<a
            style="color: #f78989"
            target="_blank" href="https://creditpower.cec.org.cn/article?id=d6acf0727bb14e3c80f254fbae4a6084"
            >>>详情</a
          >
        </p>
        <p>
          参与链接：<a
            style="color: #f78989"
            target="_blank" href="https://cp.epta.org.cn/dljs/index"
            >pc端</a
          >&nbsp;&nbsp;<a
            style="color: #f78989"
            target="_blank" href="https://cp.epta.org.cn/dlzsjs/index.html"
            >移动端</a
          >
        </p>
      </div>
    </MoveWindow> -->
  </div>
</template>

<script>
import xdcPng from "@/assets/xdc.png";
import HoverImage from "@/components/HoverImage/index";
import MoveWindow from "@/components/MoveWindow/index";
import shouye1 from "@/assets/shouye1.png";
import shouye2 from "@/assets/shouye2.png";
import shouye3 from "@/assets/shouye3.png";
import CountTo from "vue-count-to";
export default {
  name: "home-index",
  components: {
    HoverImage,
    MoveWindow,
    CountTo,
  },
  data() {
    return {
      startVal: 1990,
      endVal: 2015,
      duration: 3000,

      startVal1: 100000,
      endVal1: 300000,
      duration1: 1000,

      startVal2: 0,
      endVal2: 10,
      duration2: 3000,
      xdcPng: xdcPng,
      shouye1,
      shouye2,
      shouye3,
      bannerList: [
        {
          id: 1,
          content: shouye1,
          url: "https://www.cecdlzx.com/dlzx/#/electric",
        },
        {
          id: 2,
          content: shouye2,
          url: "https://www.cecdlzx.com/dlzx/#/login",
        },
        {
          id: 3,
          content: shouye3,
          url: "https://www.cecdlzx.com/dlzx/#/login",
        },
      ],
      key: "value",
    };
  },
  methods: {
    gotoReport() {
      this.$router.push("/report");
      location.reload();
    },
    gotoCecIndex() {
      this.$router.push("/xdc");
      location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.bannerImg {
  background: no-repeat center / cover;
  height: 320px;
  width: 100%;
}

.product {
  margin-top: 60px;
  margin-bottom: 60px;
  .h3Text {
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .threeBox {
    display: flex;
    justify-content: space-around;
    .text {
      position: relative;
      flex: 1;
      color: rgba(58, 58, 74, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 120, 255, 0.2);
      border-radius: 4px;
      margin: 30px;
      padding: 12px;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
      h4 {
        margin-top: 40px;
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
      }
      p {
        margin: 0 0 10px;
        line-height: 24px;
      }
      .DetailBtn {
        margin-top: 20px;
        text-align: center;
      }

      .titleImg,
      .titleImg1 {
        padding: 10px;
        border: 1px solid #409eff;
        border-radius: 50%;
        position: absolute;
        top: -35px;
        left: 43%;
      }
    }
    .text:hover {
      /* 鼠标移动上去后  */
      transform: scale(1.1, 1.1);
      background-color: #e8f0fe;
    }
  }
}

.product1 {
  margin-top: 60px;
  margin-bottom: 60px;
  .h3Text {
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .threeBox {
    display: flex;
    justify-content: space-around;
    .text {
      // width: 351px;
      height: 450px;
      // 1.点击放大的那种
      flex: 1;
      color: rgba(58, 58, 74, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 120, 255, 0.2);
      border-radius: 4px;
      margin: 10px;
      padding: 12px;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
      background-image: url(../../assets/youshi1.jpg);
      background-size: cover;
      // background: #3d6f98;
      opacity: 0.9;

      h4 {
        font-size: 20px;
        color: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        text-align: center;
      }
      p {
        color: #fff;
        // margin: 0 0 10px;
        line-height: 30px;
        padding: 0 10px;
      }
      .DetailBtn {
        margin-top: 20px;
        text-align: center;
      }

      .titleImg,
      .titleImg1 {
        margin-top: 50px;
        img {
          width: 80px;
          border: 1px solid #fff;
          border-radius: 50%;
          padding: 10px;
        }
        text-align: center;
      }
    }

    .text1 {
      // width: 351px;
      // height: 380px;
      // 1.点击放大的那种
      flex: 1;
      color: rgba(58, 58, 74, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 120, 255, 0.2);
      border-radius: 4px;
      margin: 10px;
      padding: 12px;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
      background-image: url(../../assets/youshi2.jpg);
      background-size: cover;
      // background: #3d6f98;
      opacity: 0.9;

      h4 {
        font-size: 20px;
        color: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        text-align: center;
      }
      p {
        color: #fff;
        padding: 0 10px;
        line-height: 30px;
      }
      .DetailBtn {
        margin-top: 20px;
        text-align: center;
      }

      .titleImg,
      .titleImg1 {
        margin-top: 50px;
        img {
          width: 80px;
          border: 1px solid #fff;
          border-radius: 50%;
          padding: 10px;
        }

        text-align: center;
      }
    }
    .text2 {
      // width: 351px;
      height: 220px;
      // 1.点击放大的那种
      flex: 1;
      color: rgba(58, 58, 74, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 120, 255, 0.2);
      border-radius: 4px;
      margin: 10px;
      padding: 12px;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
      background-image: url(../../assets/youshi3.jpg);
      background-size: cover;
      // background: #3d6f98;
      opacity: 0.9;

      h4 {
        font-size: 20px;
        color: #fff;
        margin-top: 2px;
        margin-bottom: 10px;
        font-weight: bold;
        text-align: center;
      }
      p {
        color: #fff;
        padding: 0 10px;
        line-height: 25px;
      }
      .DetailBtn {
        margin-top: 20px;
        text-align: center;
      }

      .titleImg,
      .titleImg1 {
        margin-top: 5px;
        img {
          width: 60px;
          border: 1px solid #fff;
          border-radius: 50%;
          padding: 5px;
        }

        text-align: center;
      }
    }

    .text3 {
      width: 380px;
      height: 220px;
      // 1.点击放大的那种
      flex: 1;
      color: rgba(58, 58, 74, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 120, 255, 0.2);
      border-radius: 4px;
      margin: 10px;
      padding: 12px;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
      background-image: url(../../assets/youshi4.png);
      background-size: cover;
      // background: #3d6f98;
      opacity: 0.9;

      h4 {
        font-size: 20px;
        color: #fff;
        margin-top: 5px;
        margin-bottom: 10px;
        font-weight: bold;
        text-align: center;
      }
      p {
        color: #fff;
        padding: 0 10px;
        line-height: 25px;
      }
      .DetailBtn {
        margin-top: 20px;
        text-align: center;
      }

      .titleImg,
      .titleImg1 {
        margin-top: 5px;
        img {
          width: 60px;
          border: 1px solid #fff;
          border-radius: 50%;
          padding: 5px;
        }

        text-align: center;
      }
    }
    .text:hover {
      /* 鼠标移动上去后  */
      transform: scale(1.1, 1.1);
      background-color: #e8f0fe;
    }
    .text1:hover {
      /* 鼠标移动上去后  */
      transform: scale(1.1, 1.1);
      background-color: #e8f0fe;
    }
    .text2:hover {
      /* 鼠标移动上去后  */
      transform: scale(1.1, 1.1);
      background-color: #e8f0fe;
    }
    .text3:hover {
      /* 鼠标移动上去后  */
      transform: scale(1.1, 1.1);
      background-color: #e8f0fe;
    }
  }
}

.partner {
  // margin: 10px 0;
  .h3Text {
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }

  .list {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      width: 150px;
      height: 60px;
    }
  }
}

.xuanchuan {
  display: flex;
  justify-content: space-around;

  .first {
    margin-top: 30px;
    width: 277px;
    height: 100px;
    background: #e8f0fe;
    box-shadow: 0 1px 5px #0000002b;
    display: flex;
    transform-origin: 50% 50%;
    /* 设置过渡动画 */
    transition: all 1s;
    padding: 25px 45px;
    .left {
      .iconCss {
        width: 50px;
        margin-top: -5px;
        margin-right: 10px;
        color: #409eff;
        font-size: 60px;
      }
    }
    .right {
      .top {
        font-size: 25px;
        font-weight: 700;
      }
      .bottom {
        font-size: 14px;
      }
    }
  }

  .first:hover {
    /* 鼠标移动上去后  */
    transform: scale(1.2, 1.2);
  }
}
</style>
